import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { Col, Container, Row } from '../../VuexyDesign/atoms/_index';
import { useIsDesktop, useIsMobile } from '../../style/constants';
import DistributionButton from './DistributionButton';

function DistributionStreamingPlatform() {
  const { t } = useTranslation('distributionLanding');

  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();

  const getButton = () => (
    <DistributionButton
      type="GRADIENT_FILLED"
      text={
        t(
          'distributionLanding:distributeStreamingPlatforms.distributeMusicToday',
        ) as string
      }
    />
  );

  return (
    <>
      <Container className="d-flex align-items-center mx-auto">
        <Row
          className={`align-items-center mx-auto ${
            isMobile ? 'flex-column w-100' : 'w-75'
          }`}
        >
          <Col md={12} lg={6} className="mb-md-0">
            <div className="d-flex align-items-center justify-content-center">
              <Image
                src={`${
                  isMobile
                    ? '/static/images/distribution-landing/logos_cicle_mobile.webp'
                    : '/static/images/distribution-landing/logos_cicle_desktop.webp'
                }`}
                width={isMobile ? 260 : 400}
                height={isMobile ? 290 : 450}
                className="pointer-events-none"
                alt="Music distribution"
              />
            </div>
          </Col>
          <Col
            md={12}
            lg={6}
            className={`${isDesktop ? '' : 'text-center'} mt-4`}
          >
            <h2 className="custom-heading-font-2">
              {
                t(
                  'distributionLanding:distributeStreamingPlatforms.distributeMajorPlatformTitlePartOne',
                ) as string
              }
            </h2>

            <div className={`mt-1 ${isDesktop ? 'w-75' : 'text-center w-100'}`}>
              <p className="custom-font-text-regular-normal paragraph-color">
                {
                  t(
                    'distributionLanding:distributeStreamingPlatforms.distributeMajorPlatformSubTitle',
                  ) as string
                }{' '}
                <a
                  href="https://open.spotify.com/__noul__?pfhp=2c2ccb58-8a92-4713-a1c0-8b43b3090b49"
                  style={{ color: '#0A5AF5 ' }}
                  className="text-nowrap"
                  target="_blank"
                  rel="noreferrer"
                >
                  {
                    t(
                      'distributionLanding:distributeStreamingPlatforms.distributeMajorPlatformSubTitlePartOne',
                    ) as string
                  }
                </a>{' '}
                {
                  t(
                    'distributionLanding:distributeStreamingPlatforms.distributeMajorPlatformSubTitlePartTwo',
                  ) as string
                }{' '}
                <a
                  href="https://www.apple.com/apple-music/"
                  style={{ color: '#0A5AF5 ' }}
                  className="text-nowrap"
                  target="_blank"
                  rel="noreferrer"
                >
                  {
                    t(
                      'distributionLanding:distributeStreamingPlatforms.distributeMajorPlatformSubTitlePartThree',
                    ) as string
                  }
                </a>
              </p>
            </div>
            <div
              className={`d-flex flex-column flex-md-row  mt-1 ${
                isDesktop ? '' : 'justify-content-center'
              }`}
            >
              <div className="mr-md-1 d-flex justify-content-center ">
                <div>
                  <Image
                    src="/static/images/distribution-landing/green_right_circle.png"
                    height={20}
                    width={20}
                    className="pointer-events-none "
                    alt="green right for keep rights"
                  />
                </div>
                <div className="ml-1">
                  {
                    t(
                      'distributionLanding:distributeStreamingPlatforms.keepRights',
                    ) as string
                  }
                </div>
              </div>
              <div
                style={{
                  marginRight: `${isMobile ? '1.8rem' : ''}`,
                }}
                className="d-flex  mt-1 mt-md-0 justify-content-center"
              >
                <div>
                  <Image
                    src="/static/images/distribution-landing/green_right_circle.png"
                    height={20}
                    width={20}
                    className="pointer-events-none"
                    alt="green right for keep rights"
                  />
                </div>
                <div className="ml-1">
                  {
                    t(
                      'distributionLanding:distributeStreamingPlatforms.monetizeMusic',
                    ) as string
                  }
                </div>
              </div>
            </div>
            <div
              className={`d-flex flex-column flex-md-row align-items-md-center mt-2 ${
                isDesktop ? '' : 'justify-content-center'
              }`}
            >
              {getButton()}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default DistributionStreamingPlatform;
